import { supabaseClient } from 'supabase'
import type { VenueAliasRow } from 'pages/Desk/venueNameKey'

/** Postgres unique_violation: venue_aliases_venue_alias_key (venue_id, lower(btrim(alias))). */
const UNIQUE_VIOLATION = '23505'

/**
 * Remember another name for a listed venue (the desk's Remember offer,
 * spec-editor-venue-matching §A, 33.4 D-16).
 *
 * The payload is exactly `{ alias, venue_id }`:
 *   - `created_by` is never sent. The DB default (auth.uid()) fills it and the
 *     0039 insert policy requires it to equal auth.uid() (T-33.4-23).
 *   - Always `.insert`, never an insert-or-update: there is no UPDATE policy
 *     on the table (0039, D-12; the 0028:300 rule), and an insert-or-update
 *     could overwrite a row another admin wrote (T-33.4-24).
 *
 * The same alias already stored for the venue (compared as
 * lower(btrim(alias))) is a 23505, which resolves 'already': the name is
 * remembered either way, and it is not retried with changes. Every other
 * error rejects.
 */
export const insertVenueAlias = async (row: VenueAliasRow): Promise<'inserted' | 'already'> => {
  const { error } = await supabaseClient
    .from('venue_aliases')
    .insert({ alias: row.alias, venue_id: row.venue_id })

  if (error) {
    if (error.code === UNIQUE_VIOLATION) {
      return 'already'
    }
    throw error
  }
  return 'inserted'
}
